export default __webpack_public_path__ + "static/media/Brand of Shaulun.9f23cbf9.jpg";